// Demo-only display overrides (isDemo), keyed by issue/project id. Override the
// SHOWN Kodem Score + internet-facing insight only; real values are untouched.
// Exploitable -> boosted above the real 790, not-exploitable -> dropped.

export const ISSUE_KODEM_SCORE_OVERRIDES: Record<string, number> = {
  // Exploitable -> boosted
  f426a0768a869293a9c9442be81b88dc: 948, // kodem-demo/money-transaction-validator
  "858e8f86a568a11fca7b25a14850a5a4": 946, // sooperset/mcp-atlassian
  // Not exploitable -> dropped
  "68373ffc8832fdedd4ac14e31ffce4c3": 118, // kodem-demo/k8s-monitoring
  ee7d5419f6f3f0d34aa2e154ea669566: 116, // kodem-demo/order-fulfillment-svc
  ed7aea8b9fdbbb923b43f61627c9f6b9: 114, // kodem-demo/support-ticket-router
  "51c5f0d50d49024d74fb5b2034bfe9dd": 112, // kodem-demo/invoice-reconciler
  "2f98acf6eba5bd30cb7f282956902576": 110 // kodem-demo/crm-contact-sync
}

export const PROJECT_KODEM_SCORE_OVERRIDES: Record<string, number> = {
  // Exploitable -> boosted
  "6337626463313663346462663833353233353337666463636462346238666632": 948, // kodem-demo/money-transaction-validator
  "6777d75159c544c58c9df2fbd87d084b": 946, // sooperset/mcp-atlassian
  // Not exploitable -> dropped
  "6237613430656133616664366538643832643563306462623532643138373037": 118, // kodem-demo/k8s-monitoring
  "3937303766666563316135323638623139343530346434636639303361336265": 116, // kodem-demo/order-fulfillment-svc
  "3932343837626364316338653262333337373261373933343633613437313561": 114, // kodem-demo/support-ticket-router
  "3461386139386235303439633434316439376133366630623236383232343333": 112, // kodem-demo/invoice-reconciler
  "3030666466353337613431333936303263336634313666366334386263376234": 110 // kodem-demo/crm-contact-sync
}

// Also show the internet-facing insight (the exploitable pair only).
export const ISSUE_INTERNET_FACING_IDS = new Set<string>([
  "f426a0768a869293a9c9442be81b88dc", // kodem-demo/money-transaction-validator
  "858e8f86a568a11fca7b25a14850a5a4" // sooperset/mcp-atlassian
])

export const PROJECT_INTERNET_FACING_IDS = new Set<string>([
  "6337626463313663346462663833353233353337666463636462346238666632", // kodem-demo/money-transaction-validator
  "6777d75159c544c58c9df2fbd87d084b" // sooperset/mcp-atlassian
])
